module.exports = __webpack_public_path__ + "media/images/icons/icon_arrow_right_blue-df7841b3cedd9acf054671b1b8735cb5.svg";